/*
THIS COMPONENT INCLUDING IN MANY ADMIN PAGES
 ---------------------------------------------*/
import {translate} from '../../../js/functions';

var LatinTranslater = function () {

    var getTitle = function () {
        var field = $('input.latin_original_field');
        if (!field.length) {
            console.log('Field with name "title" not found!');
        }

        return field.val();
    };

    var translateToLatin = function (field) {
        var title = getTitle();
        var translated = translate(title);

        field = field || $('input.latin_translated_field');

        replaceTranslated(translated, field);
    };

    var replaceTranslated = function (translated, field) {
        if (!field.length) {
            console.log('Field with name "link" not found!');
        }

        field.val(translated);
    };

    var getLinkField = function (obj) {
        var fieldName = obj.data('field');
        if (!fieldName.length) {
            console.log('Field for link not found!');
            return null;
        }

        return $('input[name="' + fieldName + '"]');
    };

    var init = function () {
        $('#translate_button').on('click', function() {
            translateToLatin(null);
        });

        $('.translate_button').on('click', function() {
            translateToLatin(getLinkField($(this)));
        });
    };

    return {
        init: init
    };

} ();

export default LatinTranslater;
